import axios from "axios"
import config from "../../config"
import { saveAs } from 'file-saver'
import { isChangeNumber } from '../../plugins/form-check'
import { cloneDeep } from 'lodash'
import Vue from 'vue'

const initialState = {
  sheetContentPages: null,
  usedItems: [],
  enableItems:null,
  duplicatedAnswers: [],
  alertMessage: null,
  warningMessage: null,
  contentTotalScores: [],
  sheetSearchCondition: {},
  title: '',
  pdfDlFlg: false,
  requestCode: '',
  questionImages: [],
  answerImages: [],
  answerSheetImages: [],
  answerImageErrors:'',
  answerReductionType: null,
  pdfParams: {},
  targetContent: {},
  isUpdate: {
    question: false,
    answer: false,
    answerSheet: false
  },
  isUseAllotArea: true,
  printType: 'print',
  sheetType: null,
}

// プリセットデータの内部表現への変換処理
const InternalPresetConverter = {
  uniq(strarray) {
    let uniqueStrs = {}
    let count = 1
    for(const str of strarray) {
      if (!uniqueStrs[str]) {
        uniqueStrs[str] = [str, count++]
      }
    }
    return Object.values(uniqueStrs).sort((x,y) => x[1] - y[1]).map(x => x[0])
  },

  createSubjectName(item) {
    if (config.hasOptionSubjects.includes(item.subject_code)) {
      const options = this.uniq(item.preset_details.map(detail => detail.subject_name))
      return `${item.subject_name}(${options})`
    } else {
      return item.subject_name
    }
  },
  isSingleSubjectMode(item) {
    if (item.preset_details.length === 1) return true
    const subjects = new Set(item.preset_details.map(detail => detail.subject_name))
    if (subjects.size === 1) return true
    return false
  },
  createPublisherName(item) {
    if (this.isSingleSubjectMode(item)) return item.preset_details[0].publisher_name
    return this.uniq(item.preset_details.map(preset_detail => {
      return preset_detail.subject_name + '：' + preset_detail.publisher_name
    })).join('<br>')
  },
  createRange(item) {
    let rangeData = this.createRangeData(item)
    if (this.isSingleSubjectMode(item)){
      return rangeData[0].ranges.map(range => {
        if (range[1] === 0) return range[0]
        return range[0] + '~' + range[1]
      }).join(", ")
    }
    return rangeData.map(subjectRange => {
      let rangesText = subjectRange.ranges.map(range => range[0] + '~' + range[1]).join(", ")
      return subjectRange.subjectName + '：' + rangesText
    }).join('<br>')
  },
  createRangeData(item) {
    if (this.isSingleSubjectMode(item)){
      let ranges = item.preset_details.map(preset_detail => [preset_detail.start_page, preset_detail.end_page])
      return [
        {
          subjectCode: item.preset_details[0].subject_code,
          subjectName: item.preset_details[0].subject_name,
          ranges: ranges,
        }
      ]
    }

    // 教科ごとに範囲情報を整理
    const subjectToRanges = {}
    for(const preset_detail of item.preset_details) {
      if (!subjectToRanges[preset_detail.subject_code]) {
        subjectToRanges[preset_detail.subject_code] = {
          subjectCode: preset_detail.subject_code,
          subjectName: preset_detail.subject_name,
          ranges: [],
        }
      }

      subjectToRanges[preset_detail.subject_code].ranges
        .push([preset_detail.start_page, preset_detail.end_page])
    }
    return Object.values(subjectToRanges)
  },
  createQuestionNum(item) {
    if (this.isSingleSubjectMode(item)){
      return item.preset_details.reduce((sum, preset_detail) => {
        return sum + preset_detail.question_cnt
      }, 0)
    }
      // subject_nameでグルーピング
    const questionNums = {}
    item.preset_details.forEach(preset_detail => {
      if (!questionNums[preset_detail.subject_name]) questionNums[preset_detail.subject_name] = 0
      questionNums[preset_detail.subject_name] += preset_detail.question_cnt
    })
    return Object.entries(questionNums).map(([subjectName, questionCnt]) => {
      return subjectName + '：' + questionCnt
    }).join('<br>')

  },
}

export default {
  namespaced: true,

  state: cloneDeep(initialState),

  getters: {
    graphDatas: (state, getters, rootState) => {

      function convertToGraphData(arrays, type) {
        // 2次元配列を１次元配列に変換
        const simpleArr = arrays.reduce((pre,current) => {
          pre.push(...current)
          return pre
        },[])
        // 配列要素の総数を取得(分母用)
        const totalContentNum = simpleArr.length

        // typeに応じて使用するマスターデータを設定
        let masterData = []
        // 問題種類
        if(type === 'question') {
          masterData = rootState.master.allQuestionTypes.filter(x=> x.subject_id === rootState.top.selectedSubject.id)
        }
        // 解答形式
        else if(type === 'answer') {
          masterData = rootState.master.allAnswerFormats.filter(x=> x.subject_id === rootState.top.selectedSubject.id)
        }
        // 観点
        else if(type === 'point') {
          masterData = rootState.master.allPoints
        }
        // 教材種類
        else if(type === 'kind') {
          masterData = rootState.master.allMaterialKinds
        }
        // 新学社教材
        else if(type === 'material') {
          masterData = rootState.master.allMaterials.filter(x =>
            x.subject_id === rootState.top.selectedSubject.id && x.kind === 'general'
          )
        }

        // 集計し、表示用に整形
        const formatedGraphData = masterData.map(x => {
          const count = simpleArr.filter(y => y == x.id).length
          return{
            name: x.name,
            data: count > 0 ? [Math.round( count / totalContentNum * 100 )] : [0] // 小数点以下四捨五入で割合の算出（判例表示用にcount=0もデータに格納する）
          }
        })
        return formatedGraphData
      }

      //stateから各グラフ表示用データを取得
      const questionTypeIds = state.usedItems.map(x => x.questionTypeIds)
      const answerTypeIds   = state.usedItems.map(x => x.answerTypeIds)
      const pointIds        = state.usedItems.map(x => x.pointIds)
      const materialKindIds = state.usedItems.map(x => x.materialKinds)
      const shingakushaMaterialIds = rootState.master.allMaterials.filter(x =>
          x.subject_id === rootState.top.selectedSubject.id && x.kind === 'general'
        ).map(x => x.id)
      const materialIds     = state.usedItems.filter(x => x.materialIds.some(id => shingakushaMaterialIds.includes(id))).map(x => x.materialIds)

      let data = [
        {
          categories: ['問題種類'],
          series: convertToGraphData(questionTypeIds, 'question')
        },
        {
          categories: ['解答形式'],
          series: convertToGraphData(answerTypeIds, 'answer')
        },
        {
          categories: ['観点'],
          series: convertToGraphData(pointIds, 'point')
        },
        {
          categories: ['教材種類'],
          series: convertToGraphData(materialKindIds, 'kind')
        },
        {
          categories: ['新学社教材'],
          series: convertToGraphData(materialIds, 'material')
        },
      ]
      // 社会の場合、問題種類は非表示
      if (rootState.top.selectedSubject.code === config.subjects.SHAKAI) data.shift()
      // 理科の場合、問題種類は非表示
      if (rootState.top.selectedSubject.code === config.subjects.RIKA) data.shift()
      return data
    },

    // 配点用配列を整形する
    contentTotalScores(state) {
      let contentTotalScores = []
      state.usedItems.forEach((item, itemIndex) => {
        var itemTotalScores = []
        var totalScore = 0
        item.sheetQuestions.forEach((sheetQuestion, sheetQuestionIndex) => {
          const sheetQuestionId = sheetQuestion.id
          const allot = sheetQuestion.allot
          itemTotalScores.push( {
            sheetQuestionId:sheetQuestionId,
            allot:allot,
            sortNo: sheetQuestionIndex + 1
          } )
          if (isChangeNumber(allot)) totalScore += Number(allot) * sheetQuestion.question.question_cnt //入力値は文字列で渡ってきている
        })
        contentTotalScores.push({
          itemTotalScores:itemTotalScores,
          totalScore:totalScore,
          id: item.id,
          sortNo: itemIndex + 1
        })
      })
      return contentTotalScores
    },
    // update
    getIsUpdate(state){
      const allIsUpdate = [
        state.isUpdate.question,
        state.isUpdate.answer,
        state.isUpdate.answerSheet
      ].includes(true)

      var result = {
        'all': allIsUpdate,
        'question': state.isUpdate.question,
        'answer': state.isUpdate.answer,
        'answerSheet': state.isUpdate.answerSheet,
      }
      return result
    },
    // トータル設問数
    totalQuestionCount(state) {
      return state.usedItems.reduce((total, item) => {
        return total += item.questionCnt
      }, 0)
    },
    // 社会の場合は分野ごとの合計設問数
    perSubjectQuestionCount(state) {
      return state.usedItems.reduce((total, item) => {
        if (!total[item.subjectCode]) total[item.subjectCode] = 0
        total[item.subjectCode] += item.questionCnt
        return total
      }, {})
    },
    // プリセット問題作成か
    isPresetMode(state) {
      return !!state.sheetSearchCondition?.preset_id
    },
    // 出題する問題の全解答
    allUsedItemsAnswers(state, getters, rootState) {
      if (!state.usedItems.length) return []
      // 解答重複チェックしない解答形式のid
      const nonCheckAnswerFormatIds = rootState.master.allAnswerFormats
        .filter(x => config.nonCheckAnswerFormatCodes.includes(x.code))
        .map(x => x.id)
      // 解答テキストから削除する文字
      const replaceExampleChars = ['（例）', '（例）', '（例）', '例', '（例)', '(例)', '(例）', '例 ', '例', '・（例）']
      const replaceKatakanaChars = ["ア", "ィ", "イ", "ゥ", "ウ", "ェ", "エ", "ォ", "オ", "カ", "ガ", "キ", "ギ", "ク", "グ", "ケ", "ゲ", "コ", "ゴ", "サ", "ザ", "シ", "ジ", "ス", "ズ", "セ", "ゼ", "ソ", "ゾ", "タ", "ダ", "チ", "ヂ", "ッ", "ツ", "ヅ", "テ", "デ", "ト", "ド", "ナ", "ニ", "ヌ", "ネ", "ノ", "ハ", "バ", "パ", "ヒ", "ビ", "ピ", "フ", "ブ", "プ", "ヘ", "ベ", "ペ", "ホ", "ボ", "ポ", "マ", "ミ", "ム", "メ", "モ", "ャ", "ヤ", "ュ", "ユ", "ョ", "ヨ", "ラ", "リ", "ル", "レ", "ロ", "ヮ", "ワ", "ヰ", "ヱ", "ヲ", "ン"]
      const replaceHiraganaChars = ["あ", "ぃ", "い", "ぅ", "う", "ぇ", "え", "ぉ", "お", "か", "が", "き", "ぎ", "く", "ぐ", "け", "げ", "こ", "ご", "さ", "ざ", "し", "じ", "す", "ず", "せ", "ぜ", "そ", "ぞ", "た", "だ", "ち", "ぢ", "っ", "つ", "づ", "て", "で", "と", "ど", "な", "に", "ぬ", "ね", "の", "は", "ば", "ぱ", "ひ", "び", "ぴ", "ふ", "ぶ", "ぷ", "へ", "べ", "ぺ", "ほ", "ぼ", "ぽ", "ま", "み", "む", "め", "も", "ゃ", "や", "ゅ", "ゆ", "ょ", "よ", "ら", "り", "る", "れ", "ろ", "ゎ", "わ", "ゐ", "ゑ", "を", "ん"]
      const replaceAlphabetChars = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]
      const replaceTargetChars = replaceKatakanaChars.concat(replaceHiraganaChars).concat(replaceAlphabetChars)

      return state.usedItems.map(item => {
        const answers = item.sheetQuestions.map(sheetQuestion => {
          const q = sheetQuestion.question
          // 解答テキストがnullなら空配列を返す
          if (!q.answer) return []
          // 重複チェック対象外の解答形式の場合は空配列を返す
          if (nonCheckAnswerFormatIds.includes(q.answer_format_id)) return []

          let answer = q.answer
          // 例を含む文字列群は削除削除対象の文字を解答テキストから削除
          replaceExampleChars.forEach(char =>
            answer = answer.replaceAll(char, '')
          )


          let results = answer.split('_').map(a => a.split('|')).flat()
          results = results.map(r => r.trim())

          // 記号問題は対象から外す
          results = results.filter(result => !replaceTargetChars.includes(result))

          return results
        }).flat()

        return { contentId: item.id, answers: answers}
      })
    },
    // 表示用のプリセットデータへの変換
    convertPresetData: () => (externalPreset) => {
      const preset = {
        id:             externalPreset.id,
        title:          externalPreset.name,
        subjectName:    externalPreset.subject_name,
        subjectCode:    externalPreset.subject_code,
        subject:        InternalPresetConverter.createSubjectName(externalPreset),
        textbook:       InternalPresetConverter.createPublisherName(externalPreset),
        range:          InternalPresetConverter.createRange(externalPreset),
        rangeData:      InternalPresetConverter.createRangeData(externalPreset),
        // MEMO: questionNumを取得するロジックが変わったためコメントアウト
        // questionNum:    InternalPresetConverter.createQuestionNum(externalPreset),
        questionNum:    externalPreset.question_cnt,
        grade:          externalPreset.grade_name,
        details:        externalPreset.preset_details,
        materialNames:  externalPreset.material_names.join('<br>')
      }
      return preset
    },
    // ページ範囲の表示用データ
    pageRangeText: () => (contentPage) => {
      let pageRange
      if (contentPage.start_page == 999 && contentPage.end_page == 999) {
        pageRange = '-'
      }
      else if (contentPage.start_page == 0 && contentPage.end_page == 0) {
        pageRange = ''
      }
      else {
        pageRange = contentPage.start_page + '~' + contentPage.end_page + 'p'
      }
      return pageRange
    }
  },

  mutations: {
    initialize(state) {
      Object.assign(state, cloneDeep(initialState))
    },
    setSheetContentPages(state, payload) {
      state.sheetContentPages = payload.sheetContentPages
    },
    setUsedItems(state, payload) {
      // 並び替え後のnumberを保存する
      payload.usedItems.map((usedItem, index) => {
        usedItem.number = index+1
      })
      state.usedItems = payload.usedItems
    },
    setEnableItems(state, payload) {
      state.enableItems = payload.enableItems
    },
    setTargetContent(state, payload) {
      state.targetContent = payload.targetContent
    },
    setSheetSearchCondition(state, payload) {
      state.sheetSearchCondition = payload.sheetSearchCondition
    },
    setTitle(state, payload) {
      state.title = payload.title
    },
    setPdfDlFlg(state, payload) {
      state.pdfDlFlg = payload.pdfDlFlg
    },
    setRequestCode(state, payload) {
      state.requestCode = payload.requestCode
    },
    setDuplicatedAnswers(state, payload) {
      state.duplicatedAnswers = payload.duplicatedAnswers
    },
    setSplicedUsedItems(state, payload) {
      // 削除ボタンクリックで実行される大問削除メソッド
      state.usedItems.splice(payload.targetIndex, 1)
      // 並び順を保存する
      state.usedItems.map((usedItem, index) => {
        usedItem.number = index+1
      })
    },
    setReplacedUsedItems(state, payload) {
      let targetPartNo = payload.targetPartNo
      let targetIndex  = payload.targetIndex
      let replaceFlg   = false

      if(state.usedItems.length >= payload.limitItemCount && (payload.mode === 'addPrev' || payload.mode === 'addNext')){
        Vue.toasted.global.error({ message: `${payload.limitItemCount}問までしか出題することができません` })
        return
      }

      if(payload.mode === 'addPrev') {         // １つ上に追加
        // targetPartNoはそのままでOK
        // 出題する問題に追加後、候補問題から削除
        state.enableItems.splice(targetIndex, 1)
      } else if(payload.mode === 'addNext') {  // １つ下に追加
        targetPartNo++
        // 出題する問題に追加後、候補問題から削除
        state.enableItems.splice(targetIndex, 1)
      } else if(payload.mode === 'change') {   // 差し替える
        const removeItem = state.usedItems[targetPartNo]
        replaceFlg = true
        // 出題する問題と候補問題を差し替える
        state.enableItems.splice(targetIndex, replaceFlg, removeItem)
      }
      // 出題する問題に対して差し替え・追加処理
      state.usedItems.splice(targetPartNo, replaceFlg, payload.replaceContent)

      // 並び替え後のnumberを保存する
      state.usedItems.map((usedItem, index) => {
        usedItem.number = index+1
      })
    },
    setAlertMessage(state) {
      state.alertMessage = ''
      // エラーメッセージ生成
      state.duplicatedAnswers.map(x => {
        state.usedItems.map((val,key) => {
          if(val.id === x.contentId) {
            x.partNo = key+1        // 大問番号を取得
          } else if(val.id === x.replaceContentId) {
            x.replacePartNo = key+1 // 大問番号を取得
          }
        })
        if(x.partNo && x.replacePartNo) {
          const partNoA = x.partNo < x.replacePartNo ? x.partNo : x.replacePartNo
          const partNoB = x.partNo > x.replacePartNo ? x.partNo : x.replacePartNo
          state.alertMessage += '大問'+partNoA+' と 大問'+partNoB+' で 解答：【'+ x.answer + '】 が重複しています。<br>'
        }
      })
    },
    setFavoriteEnableItem(state, payload) {
      const content = state.enableItems.find((item) => item.id === payload.contentId)
      content.favoriteContentId = payload.favoriteContentId
      content.isFavorite = !!payload.favoriteContentId
    },
    setFavoriteUsedItem(state, payload) {
      const content = state.usedItems.find((item) => item.id === payload.contentId)
      content.favoriteContentId = payload.favoriteContentId
      content.isFavorite = !!payload.favoriteContentId
    },
    setWarningMessage(state, payload) {
      state.warningMessage = payload.message
    },
    // 配点や観点の変更を反映する
    setChangedItems(state, payload) {
      //対象大問のコピーを作成
      const replaceContent = state.usedItems[payload.targetItemIndex]
      //その大問の対象小問の設定を変更
      if(payload.mode === 'score') {
        replaceContent.sheetQuestions[payload.targetQuestionIndex].allot   = payload.changedAllot
      } else if(payload.mode === 'viewPoint') {
        replaceContent.sheetQuestions[payload.targetQuestionIndex].pointId = payload.changedPointId //グラフ表示には不要だが、テスト登録・更新時に必要
        replaceContent.pointIds[payload.targetQuestionIndex]               = payload.changedPointId //グラフ更新用
        //対象大問を配点や観点変更後のデータを差し替える（これでグラフ自動反映される）
        state.usedItems.splice(payload.targetItemIndex, 1, replaceContent)
      }
    },
    // 画像セット
    setImages(state, payload) {
      const mode = payload.mode
      state[mode + 'Images'] = payload.images
    },
    // 回答画像エラーセット
    setAnswerImageErrors(state, payload) {
      state.answerImageErrors = payload.errors
    },
    // 最小縮小率に達した時の解答用紙の縮小方法
    setAnswerReductionType(state, payload) {
      state.answerReductionType = payload.answerReductionType
    },
    // sendPDFParams
    setPdfParams(state, payload) {
      state.pdfParams = payload.pdfParams
    },
    // sendPDFParams
    setIsUpdate(state, payload) {
      const types = payload.type === 'all' ? ['question', 'answer', 'answerSheet'] : [payload.type]
      const isUpdate = payload.isUpdate
      types.forEach(type =>
        state.isUpdate[type] = isUpdate
      )
    },
    // 大問ごとの配点と解答欄の欄を使用するかしないか
    setIsUseAllotArea(state, payload) {
      state.isUseAllotArea = payload.isUseAllotArea
    },
    setPrintType(state, payload) {
      state.printType = payload.printType
    },
    setSheetType(state, payload) {
      state.sheetType = payload.sheetType
    },
  },

  actions: {
    async getSheetContents({commit, getters,rootState}, params) {
      let res = null
      commit('initialize')
      if (params.restartSheets) res = params.restartSheets
      else res = await axios.post('/api/v1/teacher/sheets', params)

      // 試験名セット
      commit('setTitle', { title: res.data.name })

      commit('setSheetType', { sheetType: res.data.sheet_type })

      commit('setSheetContentPages', {
        sheetContentPages: res.data
      })
      // レスポンスから表示用に整形
      const sheetContentPages = res.data.sheet_content_pages
      const contentPages = Object.entries(sheetContentPages).map(item => {
        return {
          // コンテンツ単位の表示用
          sheetContentPageId: item[1].id,
          id:              Number(item[1].content_page.content.id),
          gradeId:         Number(item[1].content_page.content.grade_id),
          contentCode:     item[1].content_page.content.code,
          pageRange:       getters.pageRangeText(item[1].content_page),
          questionCnt:     item[1].content_page.content.question_cnt,
          usedTime:        item[1].content_page.content.used_cnt,
          usedCntByFiscalYear: item[1].content_page.content.used_cnt_by_fiscal_year,
          material:        item[1].content_page.content.materials.map(material => material.name).join(', '),
          subjectCode:     item[1].content_page.content.subject_code,
          athleticEvent:   item[1].content_page.content.athletic_events.map(athletic => athletic.name).join(', '),
          // 大問プレビュー用
          questionImage:   item[1].content_page.content.question_image_urls,
          answerImage:     item[1].content_page.content.answer_image_urls,
          scriptImage:     item[1].content_page.content.script_image_urls ? item[1].content_page.content.script_image_urls : [null],
          // グラフ整形用
          chapterName:     item[1].content_page.content.chapter_name,
          questionTypeIds: item[1].content_page.content.questions.map(question => question.question_type_id),
          answerTypeIds:   item[1].content_page.content.questions.map(question => question.answer_format_id),
          pointIds:        item[1].sheet_questions.map(sheet_question => sheet_question.point_id),// pointIdsだけはsheet_questionsの値を参照する（観点変更後、再開することもあるから）
          viewPoint:       rootState.master.allPoints.find((p) => p.id === item[1].content_page.content.questions[0].point_id).name,
          materialKinds:   item[1].content_page.content.materials.map(material => material.kind),
          materialIds:     item[1].content_page.content.materials.map(material => material.id),
          // 解答重複チェック用
          answers:         item[1].content_page.content.questions.map(question => question.answer),
          // 更新用
          number:          item[1].number,
          contentPageId:   item[1].content_page.id,
          // リスニング再生時間
          listeningTime:   item[1].content_page.content.listening_time,
          favoriteContentId: item[1].content_page.content.favorite_content_id,
          isFavorite:      !!item[1].content_page.content.favorite_content_id,
          shinkenkyuNumber: item[1].content_page.content.shinkenkyu_number
            ? "単元" + String(item[1].content_page.content.shinkenkyu_number).padStart(2, '0')
            : null,
          sheetQuestions:  item[1].sheet_questions.map(sheet_question => {
            return {
              id:         sheet_question.id,
              questionId: sheet_question.question_id,
              number:     sheet_question.number,
              allot:      sheet_question.allot,
              pointId:    sheet_question.point_id,
              question:   sheet_question.question,
            }
          }),
        }
      })
      commit('setUsedItems', {
        usedItems: contentPages
      })

      // 画像パス
      const pathNameMap = [
        { mode: 'question', key_name:'question_sheet_file_paths' },
        { mode: 'answer', key_name:'answer_file_paths' },
        { mode: 'answerSheet', key_name:'answer_sheet_file_paths' },
      ]
      pathNameMap.forEach(el => {
        const images = res.data[el.key_name]
        commit('setImages', {
          mode: el.mode,
          images: images || []
        })
      })

      // 最小縮小率に達した時の解答用紙の縮小方法セット
      commit('setAnswerImageErrors', {errors: res.data.answer_errors})
      commit('setAnswerReductionType', { answerReductionType: res.data.answer_reduction_type })
    },
    // 途中保存処理
    async updateSheetStatus({state,commit,getters,rootState}, params) {
      const targetSheetId = state.sheetContentPages.id
      const res = await axios.put('/api/v1/teacher/sheets/' + targetSheetId, params)
      commit('setSheetContentPages', {
        sheetContentPages: res.data
      })
      // レスポンスから表示用に整形
      const contentPages = []
      const sheetContentPages = res.data.sheet_content_pages
      Object.entries(sheetContentPages).map(item => {
        contentPages.push({
          // コンテンツ単位の表示用
          sheetContentPageId: item[1].id,
          id:              Number(item[1].content_page.content.id),
          gradeId:         Number(item[1].content_page.content.grade_id),
          contentCode:     item[1].content_page.content.code,
          pageRange:       getters.pageRangeText(item[1].content_page),
          questionCnt:     item[1].content_page.content.question_cnt,
          usedTime:        item[1].content_page.content.used_cnt,
          usedCntByFiscalYear: item[1].content_page.content.used_cnt_by_fiscal_year,
          material:        item[1].content_page.content.materials.map(material => material.name).join(', '),
          subject:         item[1].content_page.content.subject,
          subjectCode:     item[1].content_page.content.subject_code,
          athleticEvent:   item[1].content_page.content.athletic_events.map(athletic => athletic.name).join(', '),
          // 大問プレビュー用
          questionImage:   item[1].content_page.content.question_image_urls,
          answerImage:     item[1].content_page.content.answer_image_urls,
          scriptImage:     item[1].content_page.content.script_image_urls ? item[1].content_page.content.script_image_urls : [null],
          // グラフ整形用
          chapterName:     item[1].content_page.content.chapter_name,
          questionTypeIds: item[1].content_page.content.questions.map(question => question.question_type_id),
          answerTypeIds:   item[1].content_page.content.questions.map(question => question.answer_format_id),
          pointIds:        item[1].sheet_questions.map(sheet_question => sheet_question.point_id),// pointIdsだけはsheet_questionsの値を参照する（観点変更後、再開することもあるから）
          viewPoint:       rootState.master.allPoints.find((p) => p.id === item[1].content_page.content.questions[0].point_id).name,
          materialKinds:   item[1].content_page.content.materials.map(material => material.kind),
          materialIds:     item[1].content_page.content.materials.map(material => material.id),
          // 解答重複チェック用
          answers:         item[1].content_page.content.questions.map(question => question.answer),
          // 更新用
          number:          item[1].number,
          contentPageId:   item[1].content_page.id,
          // リスニング再生時間
          listeningTime:   item[1].content_page.content.listening_time,
          favoriteContentId: item[1].content_page.content.favorite_content_id,
          isFavorite:      !!item[1].content_page.content.favorite_content_id,
          shinkenkyuNumber: item[1].content_page.content.shinkenkyu_number
            ? "単元" + String(item[1].content_page.content.shinkenkyu_number).padStart(2, '0')
            : null,
          sheetQuestions:  item[1].sheet_questions.map(sheet_question => {
            return {
              id:         sheet_question.id,
              questionId: sheet_question.question_id,
              number:     sheet_question.number,
              allot:      sheet_question.allot,
              pointId:    sheet_question.point_id,
              question:   sheet_question.question
            }
          }),
        })
      })
      commit('setUsedItems', {
        usedItems: contentPages
      })
      // 最小縮小率に達した時の解答用紙の縮小方法セット
      commit('setAnswerReductionType', { answerReductionType: res.data.answer_reduction_type })

      let message = ''
      if(res.status !== 200) {
        message = 'テストの保存に失敗しました。'
      } else {
        message = 'テストを保存しました。'
      }
      return {message: message }
    },

    async getSheetImages({ state, commit, dispatch, getters }, payload) {
      // sendParams
      var { params } = payload
      var allParams = { params }
      const targetSheetId = params.targetSheetId ?? state.sheetContentPages.id
      allParams.params.makeType = 'preview'
      await dispatch('makeSendParams', allParams)
      const sendParams = state.pdfParams
      // var isUpdate = false
      const pdfType = state.pdfParams.type

      // 一回出力した場合はUPDATEがない限り作り直さない
      const isUpdate = getters.getIsUpdate[pdfType]
      if (!isUpdate) return

      // エラーリセット
      commit('setAnswerImageErrors', {errors: ''})


      // data取得
      const res = await axios.post('/api/v1/teacher/sheets/' + targetSheetId + '/create_pdf', sendParams)
      const answerImageErrors = res.data.answer_errors
      const answerReductionType = res.data.answer_reduction_type
      // storeにセット
      commit('setAnswerImageErrors', {errors: answerImageErrors})
      commit('setAnswerReductionType', {answerReductionType: answerReductionType})
      const pathNameMap = [
        { mode: 'question', key_name:'question_sheet_file_paths' },
        { mode: 'answer', key_name:'answer_file_paths' },
        { mode: 'answerSheet', key_name:'answer_sheet_file_paths' },
      ]
      pathNameMap.forEach(el => {
        const images = res.data[el.key_name]
        commit('setImages', {
          mode: el.mode,
          images: images || []
        })
      })
      // UPDATE更新
      commit('setIsUpdate', {type: pdfType, isUpdate: false})
    },

    // PDFDOWNLOAD
    // var mode = 'question'
    // await this.$store.dispatch('sheet/pdfDownload', {params:{type:mode}})
    async pdfDownload({ state, dispatch }, payload){
      // sendparams
      var { params } = payload
      var allParams = { params }
      const targetSheetId = state.sheetContentPages.id
      allParams.params.makeType = 'download'
      await dispatch('makeSendParams', allParams)
      const sendParams = state.pdfParams
      // data取得
      const res = await axios.post('/api/v1/teacher/sheets/' + targetSheetId + '/download', sendParams, {responseType: 'blob'})
      const blob = new Blob([res.data], { type: res.data.type })
      const fileName = "test.pdf"
      saveAs(blob, fileName)
    },

    // zipDOWNLOAD
    async zipDownload({ state, dispatch }, payload){
      // sendparams
      var { params } = payload
      var allParams = { params }
      const targetSheetId = state.sheetContentPages.id
      allParams.params.makeType = 'download'
      await dispatch('makeSendParams', allParams)
      const sendParams = state.pdfParams
      // data取得
      const res = await axios.post('/api/v1/teacher/sheets/' + targetSheetId + '/create_zip', sendParams, {responseType: 'blob', dataType: 'binary'})
      const blob = new Blob([res.data], { type: res.data.type })
      //レスポンスヘッダからファイル名を取得
      const contentDisposition = res.headers['content-disposition']
      let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2,
                                                    contentDisposition.length
                                                 )
      //デコードするとスペースが"+"になるのでスペースへ置換
      fileName = decodeURI(fileName).replace(/\+/g, ' ')
      saveAs(blob, fileName)
    },

    // 組版
    async compose ({state,rootState}) {
      const params = {
        Title: state.title,
        SheetId: state.sheetContentPages.id,
        OutputType: 0,
        Subject: rootState.top.selectedSubject.code,
        QuestionSheetPrintOption: {
          FrontCover: state.printType === 'booklet',
        },
        AnswerSheetPrintOption: {},
        Question: state.usedItems.map(sheetContentPage => {
          return {                                                        //大問内容の配列
            ContentsCode: sheetContentPage.contentCode,
            Point: sheetContentPage.sheetQuestions.reduce((total, sheetQuestion) => {
              return total += sheetQuestion.allot * sheetQuestion.question.question_cnt
            }, 0),
            Question: sheetContentPage.sheetQuestions.map(sheetQuestion => {
              return {
                AspectType: sheetQuestion.pointId,
                Point: sheetQuestion.allot,
                AnswerCount: sheetQuestion.question.question_cnt,
              }
            })
          }
        }),
      }
      await axios.post('/api/composition_execute', params)
    },

    // 無料版zipDOWNLOAD
    async zipFreeDownload({ state }){
      const params = { title: state.title }
      const targetSheetId = state.sheetContentPages.id
      // data取得
      const res = await axios.post('/api/v1/teacher/sheets/' + targetSheetId + '/create_free_zip',
        params, {
          responseType: 'blob', dataType: 'binary'
        })
      const blob = new Blob([res.data], { type: res.data.type })
      //レスポンスヘッダからファイル名を取得
      const contentDisposition = res.headers['content-disposition']
      let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2,
                                                    contentDisposition.length
                                                 )
      //デコードするとスペースが"+"になるのでスペースへ置換
      fileName = decodeURI(fileName).replace(/\+/g, ' ')
      saveAs(blob, fileName)
    },

    // pdfDownloadとgetSheetImagesにapi側に送るparamsを作成
    async makeSendParams({ state, commit, rootState }, allParams){
      const { params } = allParams
      const isSample = params.isSample ?? true
      const forDemo = params.forDemo ?? false
      const makeType = params.makeType || 'preview'
      const type = params.type || 'question'
      const title = params.title || state.title
      const gradeId = config.hasOptionSubjects.includes(rootState.top.selectedSubject.code) ? params?.grade_id : null
      const pdfParams = {
        is_sample: isSample,
        for_demo: forDemo,
        title: title,
        make_type: makeType,
        grade_id: gradeId,
        answer_reduction_type: state.answerReductionType,
        type,
        is_use_allot_area: state.isUseAllotArea,
        print_type: state.printType
      }
      commit('setPdfParams', {
        pdfParams: pdfParams
      })
    },

    // 解答重複チェック
    async checkAnswerDuplicate({ commit, getters, rootState }) {
      // 解答重複チェック(数学の場合はチェックしない)
      if(rootState.top.selectedSubject.code === config.subjects.SUGAKU) return

      // 解答重複エラーを初期化
      commit('setDuplicatedAnswers', { duplicatedAnswers: [] })

      // 解答重複チェック
      const allUsedItemsAnswers = getters.allUsedItemsAnswers
      const duplicatedAnswers = []

      allUsedItemsAnswers.forEach((targetObj, index) => {
        // 最後のindexはチェックしない
        if (index + 1 === allUsedItemsAnswers.length) return

        allUsedItemsAnswers.slice(index + 1).forEach(obj => {
          // 重複してる解答テキストの配列
          const duplicatedAnswerTexts = obj.answers.filter(text =>
            targetObj.answers.includes(text)
          )
          // 重複がなければ何もしない
          if (!duplicatedAnswerTexts.length) return

          duplicatedAnswerTexts.forEach(text =>
            duplicatedAnswers.push({
              contentId: targetObj.contentId,
              replaceContentId: obj.contentId,
              answer: text
            })
          )
        })
      })
      commit('setDuplicatedAnswers', { duplicatedAnswers: duplicatedAnswers})
    },
    async deleteOrCreateFavoriteContent({ commit }, payload) {
      if (payload.favoriteContentId) {
        await axios.delete(`/api/v1/teacher/favorite_contents/${payload.favoriteContentId}`)
        commit(payload.mutationName, {
          contentId: payload.contentId,
          favoriteContentId: null
        })
      } else {
        const res = await axios.post('/api/v1/teacher/favorite_contents', {
          content_id: payload.contentId,
          subject_teacher_id: payload.subjectTeacherId
        })
        commit(payload.mutationName, {
          contentId: payload.contentId,
          favoriteContentId: res.data.id
        })
      }
    },
  },

}
